<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark>
      <v-app-bar-nav-icon @click.stop="toggleSideMenu" />
      <router-link to="/">
        <v-toolbar-title class="page-title">
          サイラボ自分カレンダー
        </v-toolbar-title>
      </router-link>
      <v-spacer />
      <v-toolbar-items>
        <v-btn
          v-if="$store.state.login_user"
          color="primary"
          dark
          @click="clickLogout">
          ログアウト
        </v-btn>
        <Login
          v-else
          color="primary"
          dark />
      </v-toolbar-items>
    </v-app-bar>
    <SideNav />

    <v-content>
      <v-container
        fluid
        fill-height
        align-start>
        <router-view />
      </v-container>
    </v-content>

    <v-footer
      app
      dark>
      <v-card-text class="py-2 text-center">
        &copy;{{ new Date().getFullYear() }} - Copyright
        株式会社サイラボ All Right Reserved
      </v-card-text>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SideNav from './components/SideNav'
import Login from './components/Login'

export default {
  name: 'App',
  components: {
    SideNav,
    Login,
  },
  data: () => ({}),
  computed: {
    ...mapGetters(['isRegisteredUser']),
  },
  created() {},
  mounted() {
    const title = 'サイラボ | 自分カレンダー'
    //const description = "株式会社サイラボの自分カレンダーです"
    document.title = title
    // document.querySelector("meta[property='og:title']").setAttribute('content', title)
    // document.querySelector("meta[name='description']").setAttribute('content', description)
    // document.querySelector("meta[property='og:description']").setAttribute('content', description)

    //ユーザがログインした際の遷移
    // const fc = (mutation, state) => {
    //   if (mutation.type === 'userMeishiki') {
    //     if (state.user_meishiki != null) {
    //       this.$router.push({ name: 'calendar' }, () => { })
    //     }
    //   }
    //   // ユーザ登録されていない場合は、登録画面へ
    //   else if (mutation.type === 'userMeishikiNotExists') {
    //     this.$router.push({ name: 'home' }, () => { })
    //   }
    // }
    // this.$store.subscribe(fc)
  },
  methods: {
    clickLogout() {
      this.logout()
      this.deleteLoginUser()
      this.$router.push({ name: 'top' })
    },
    ...mapActions([
      'toggleSideMenu',
      'setLoginUser',
      'loginGoogle',
      'logout',
      'deleteLoginUser',
      'fetchUserMeishiki',
    ]),
  },
}
</script>
<style scoped lan="scss">
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap');
.v-application {
    font-family: 'M PLUS Rounded 1c', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.page-title {
    color: white;
    text-decoration: none;
}
</style>
